var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-pm-analysis-chart"},[_c('v-chart',{ref:"pmAnalysisChart",staticClass:"chart chart-pm-analysis",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }